import { Bar, BarChart, Cell, Tooltip, XAxis, YAxis } from 'recharts';
import { MeasuredChart } from './MeasuredChart';

const labels = {
  browser: 'Browser',
  os: 'Operating system',
  device: 'Device',
  device_model: 'Device model',
  codec: 'Codec',
  stage: 'Pipeline stage',
};

const TrendChart = ({ dimension, rows }) => (
  <div className={`border border-[#EAE5D9] bg-white p-5 rounded-md ${dimension === 'stage' ? 'lg:col-span-2' : ''}`} data-testid={`voice-trend-${dimension}`}>
    <div className="mb-4 flex items-end justify-between gap-3">
      <div>
        <p className="text-xs font-semibold uppercase text-[#8A8A8A]">Failure rate by</p>
        <h3 className="mt-1 text-lg font-medium text-[#1A1A1A]">{labels[dimension]}</h3>
      </div>
      <span className="text-xs text-[#8A8A8A]">10% alert threshold</span>
    </div>
    {rows.length ? (
      <MeasuredChart className="h-56">
        {({ width, height }) => <BarChart width={width} height={height} data={rows} layout="vertical" margin={{ top: 4, right: 24, bottom: 4, left: 12 }}>
            <XAxis type="number" domain={[0, 100]} hide />
            <YAxis dataKey="name" type="category" width={96} tick={{ fill: '#5C5C5C', fontSize: 11 }} axisLine={false} tickLine={false} />
            <Tooltip
              cursor={{ fill: '#F4F1EA' }}
              formatter={(value, _name, item) => [`${value}% (${item.payload.failures}/${item.payload.sessions})`, 'Failure rate']}
              contentStyle={{ border: '1px solid #EAE5D9', borderRadius: 4, boxShadow: 'none' }}
            />
            <Bar dataKey="failure_rate" radius={[0, 3, 3, 0]}>
              {rows.map((row) => <Cell key={row.name} fill={row.failure_rate >= 10 ? '#C85A3C' : '#2C5545'} />)}
            </Bar>
          </BarChart>}
      </MeasuredChart>
    ) : (
      <div className="flex h-56 items-center justify-center text-sm text-[#8A8A8A]">No measured sessions in this range</div>
    )}
  </div>
);

export const VoiceFailureTrends = ({ trends }) => (
  <section className="space-y-4" data-testid="voice-failure-trends">
    <div>
      <p className="text-xs font-semibold uppercase text-[#8B7355]">Failure trends</p>
      <h2 className="mt-1 font-serif text-2xl text-[#1A1A1A]">Patterns worth investigating</h2>
    </div>
    <div className="grid gap-5 lg:grid-cols-2">
      {Object.keys(labels).map((dimension) => (
        <TrendChart dimension={dimension} rows={trends[dimension] || []} key={dimension} />
      ))}
    </div>
  </section>
);
